export const AuthLayout = ({ children }) => {
  return <>{children}</>;
};
